import { t } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';

import Tasks from 'APP/Tasks';
import { ServerErrorCode } from 'APP/model/error/error.constants';

// Needs Bff implementation
export default async ({ channelId, userId }) => {
  try {
    logger.get('Tasks').debug('streaming.inviteAsStreamer', { channelId, userId });

    return false;
  } catch (e) {
    logger.get('Tasks').error('streaming.inviteAsStreamer', e);

    if (e?.message === ServerErrorCode.OnlyWebPlatformSupportedManyBroadcasters) {
      Tasks.app.showAlert(t('call_invite_as_streamer_mobile_alert'));

      return false;
    }

    Tasks.app.showAlert(t('CALL_ERROR_APPEARED'));

    return false;
  }
};
